import { Component, OnInit } from '@angular/core';
import Player from '@vimeo/player';

@Component({
  selector: 'app-uu-leader',
  templateUrl: './uu-leader.component.html',
  styleUrls: ['./uu-leader.component.css']
})
export class UuLeaderComponent implements OnInit {
  headerCopy = `Contemporary Services Corporation (CSC) is recognized worldwide as the
  pioneer, expert and only employee owned company in the crowd
  management field. CSC developed the concept of peer group security
  techniques, and through over five decades of continual refinement and
  evolution, CSC has successfully remained the leader in the crowd
  management and event security industry.`;
  videoOptions: { id: number; responsive: boolean; };
  player: any;
  constructor() { }
  ngOnInit(): void {
    this.videoOptions = {
      id: 584673624,
      responsive: true
    };
    this.player = new Player('bgVid', this.videoOptions);
    this.player.play();
  }

}
